import { defineAsyncComponent } from 'vue'
import Error from '@/pages/error/error'
import store from '@/store/index'

export default (options) => {
  if (options.isPrivate && !store.getters['auth/isAuthed']) {
    return Error
  } else {
    return defineAsyncComponent({
      loader: options.loader
    })
  }
}
